import { render, staticRenderFns } from "./LatestAnalysis.vue?vue&type=template&id=2cac9174&scoped=true"
import script from "./LatestAnalysis.vue?vue&type=script&lang=js"
export * from "./LatestAnalysis.vue?vue&type=script&lang=js"
import style0 from "./LatestAnalysis.vue?vue&type=style&index=0&id=2cac9174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cac9174",
  null
  
)

export default component.exports